<div class="form-group" [formGroup]="formGroup">
  <label class="control-label">{{label}}</label>
  <ng-select class="custom" [items]="options" bindValue="value" bindLabel="label" name="formControlName"
    id="formControlName" [formControlName]="formControlNameValue" (change)="change()"></ng-select>
</div>